export default {
  API_URL: "https://partners.primevp.in/api/v1",
  // API_URL: "http://localhost:5004/api/v1",
  LOCAL_STORAGE_TOKEN_KEY: "pvp_pmt__auth__token",
  LOCAL_STORAGE_COMPANY_KEY: "pvp_pmt__company__id",
};
